// eslint-disable-next-line import/prefer-default-export
export const FANTASY_CLIENT_ID = 2;
